// Initialize BASE URL
if(false){
  var BASE_URL = "https://dash.level-sense.com/Level-Sense-API/web/app_dev.php";
}else{
  var BASE_URL = "https://dash.level-sense.com/Level-Sense-API/web";
}

$(document).ready(function(){
  //Comment click event as we are submiting the shopify support itself
  /*$(document).on('click', '#create_contact button.form__submit', function(e) {
  	//_create_support_ticket(e);
    //Just submit the ticket
    if($('#create_contact button.form__submit').length > 0) {
      $('#create_contact button.form__submit').submit();
    }
  });*/
});

function _create_support_ticket() {
  params = {};
  var _fields = {"firstName": "contact[First Name]", "lastName": "contact[Last Name]", 
                 "email": "contact[email]", "phoneNumber": "contact[phone-number]", 
                 "device": "contact[Device]", "body": "contact[body]", 
                 "address": "contact[Address]", "addressLine2": "contact[Address Line2]", 
                 "country": "contact[Country]", "stateProvinceRegion": "contact[STATE PROVINCE REGION]", 
                 "city": "contact[city]", "zipcode": "contact[zipcode]"
                };
  for(var _key in _fields) {
    if (_fields.hasOwnProperty(_key)) {
      var selector = '#create_contact [name="' + _fields[_key] + '"]';
      if($(selector).length > 0) {
        if('body' == _key) {
          _fields[_key] = $(selector).val();
        } else {
          if('email' == _key) {
            ////_sendTo
            params.email = $(selector).val();
            if(params.email == '') {
              $('#create_contact button.form__submit').submit();
              return true;
            }
          }
          _fields[_key] = $(selector).val();
        }
        
      } else {
        _fields[_key] = '';
      }
    }
  }

  params.data = _fields;
  
  $.ajax({
      url: BASE_URL+"/api/v1/contactTicket",
      type: 'POST',
      data: JSON.stringify(params),
      dataType: 'json',
      crossDomain:true,
      async:true,
      headers: {
      },
      contentType: 'application/json; charset=utf-8',
      success: function (result) {
        $('#create_contact button.form__submit').submit();
      },
      error: function (error) {
        sweetAlert("Oops...", "Something went wrong...Please try again later!", "error");
      }
    });
}